import { LabelItemProps } from '@/types/product';
import { CroppedImage } from '@weee-fe/module';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type LabelItem = {
  label: LabelItemProps;
  showBorder: boolean;
  hasRankTag: boolean;
};

const ProductLabelItem: FC<LabelItem> = ({ label, showBorder, hasRankTag }) => {
  const isPriceInvalid = label.label_position === 'price_invalid';
  return (
    <div
      data-testid={`wid-product-card-tag-${label?.label_key}`}
      className={twMerge(
        'box-border py-0 rounded-200 overflow-hidden bg-surface-100-bg',
        showBorder && 'border-[2px] border-white border-solid',
        isPriceInvalid && 'mt-50',
        hasRankTag && '-translate-x-[18px] origin-left'
      )}>
      <div
        className={twMerge(
          'flex justify-center items-center gap-x-0.5',
          'enki-body-3xs !font-semibold',
          'border-surface-100-bg  whitespace-nowrap h-[18px] px-100 box-border rounded-200 uppercase text-pricing-fg',
          isPriceInvalid && 'text-surface-100-fg-default line-through !leading-none'
        )}
        style={{ background: label?.label_color, color: label?.label_font_color }}>
        {label?.label_icon_url && (
          <CroppedImage
            wrapperClassName="w-[11px] h-[11px]"
            className="w-full h-full"
            url={label.label_icon_url}
            alt=""
            aria-hidden="true"
            configs={{ renderHeight: 11, renderWidth: 11 }}
          />
        )}
        <span className="!leading-[18px]">{label?.label_name}</span>
      </div>
    </div>
  );
};

export default ProductLabelItem;
